import { atom, useRecoilState, useResetRecoilState } from 'recoil'
import { CheckedItem } from './components/use-table-switch'

const selectedItemsState = atom<CheckedItem[]>({
  key: 'StatsWifiSelectedItemsState',
  default: []
})

const hoveredItemState = atom<CheckedItem | null>({
  key: 'StatsWifiHoveredItemState',
  default: null
})

const useSelection = () => {
  return useRecoilState(selectedItemsState)
}

export const useResetSelection = () => {
  return useResetRecoilState(selectedItemsState)
}

export const useHoveredItem = () => {
  return useRecoilState(hoveredItemState)
}

export default useSelection